import { render, staticRenderFns } from "./plotter.vue?vue&type=template&id=bb841e20&scoped=true&"
import script from "./plotter.vue?vue&type=script&lang=js&"
export * from "./plotter.vue?vue&type=script&lang=js&"
import style0 from "./plotter.vue?vue&type=style&index=0&id=bb841e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb841e20",
  null
  
)

export default component.exports